import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageHeader: {
		id: 'servicedesk-itsm-features.app.page-header',
		defaultMessage: 'Features',
		description: 'Title text of the page',
	},
	pageDescription: {
		id: 'servicedesk-itsm-features.app.page-description',
		defaultMessage:
			'Give teams access to features within this project. Enabled features appear in project navigation.',
		description: 'Description that explains the purpose of the page to the user',
	},
});
